import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import IconSelect from "./IconSelect";
import PMGColorPaletete from "./PMGColorPalette";
import {PanelBody,Panel,RangeControl,SelectControl,TextControl,Button, CheckboxControl} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    __experimentalLinkControl as LinkControl,
    MediaUploadCheck
} from '@wordpress/block-editor';

registerBlockType({
  "name":"template-scripts/image-text-block",
  "title":"Card",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    mainText:{type:'string'},
    styleVersion:{type:'string',default:'default'},
    textPosition:{type:'string',default:'text-center'},
    subText:{type:'string'},
    headerColor:{type:'string',default:'#000'},
    subTextColor:{type:'string',default:'#000'},
    textAlign:{type:'string',default:'left'},
    image:{type:'object',default:{url:'',id:''}},
    imageHeight:{type:'number',default:200},
    headerFontSize:{type:'number',default:24},
    showBorder:{type:'boolean',default:true},
    roundedCorners:{type:'boolean',default:false},
    link:{type:'object',default:{url:'',title:'',target:''}},
  }
},{
  edit:function({attributes,setAttributes}){
    return (<>
    <InspectorControls>
        <Panel>
            <PanelBody title="Button Link">
              <LinkControl placeholder="Button Link" onChange={(v)=>{ console.log({v}); setAttributes({link:v}); }} value={attributes.link}/>
            </PanelBody>
            <PanelBody title="Style Version">
              <SelectControl
                value={attributes.styleVersion}
                options={[
                  {label:"Default",value:"default"},
                  {label:"Full Image",value:"full-image"}
                ]}
                onChange={(v)=>setAttributes({styleVersion:v})}
              />
              {attributes.styleVersion == "full-image" ? (<>
              
                <SelectControl
                  value={attributes.textPosition}
                  options={[
                    {label:"Top",value:"text-top"},
                    {label:"Center",value:"text-center"},
                    {label:"Bottom",value:"text-bottom"},
                  ]}
                  onChange={(v)=>setAttributes({textPosition:v})}
                />
              </>) : (<></>)}
            </PanelBody>
            <PanelBody>

                Header Color:
                <PMGColorPaletete
                  value={attributes.headerColor}
                  onChange={(v)=>setAttributes({headerColor:v})}
                />  
                SubText Color:
                <PMGColorPaletete
                  value={attributes.subTextColor}
                  onChange={(v)=>setAttributes({subTextColor:v})}
                />  
                <RangeControl
                  label="Header Font Size"
                  value={attributes.headerFontSize}
                  onChange={(v)=>setAttributes({headerFontSize:v})}
                  min={12}
                  max={60}
                  step={1}
                />
                <RangeControl
                  label="Image Height"
                  value={attributes.imageHeight}
                  onChange={(v)=>setAttributes({imageHeight:v})}
                  min={100}
                  max={1000}
                  step={1}
                />
                <CheckboxControl
                  label="Show Border"
                  checked={attributes.showBorder}
                  onChange={(v)=>setAttributes({showBorder:v})}
                />
                <CheckboxControl
                  label="Rounded Corners"
                  checked={attributes.roundedCorners}
                  onChange={(v)=>setAttributes({roundedCorners:v})}
                />
            </PanelBody>
        </Panel>
    </InspectorControls>
      <BlockControls>
        <AlignmentToolbar
            value={ attributes.textAlign }
            onChange={ ( nextAlign ) => {
                setAttributes( { textAlign: nextAlign } );
            } }
        />
      </BlockControls>
      <div className={`imageTextBlock ${attributes.styleVersion} ${attributes.showBorder ? "showBorder" : ""} ${attributes.roundedCorners ? "roundedCorners" : ""}`} style={{textAlign:attributes.textAlign}}>
        <MediaUploadCheck>
          <MediaUpload
            onSelect={(selectedImage)=>setAttributes({image:selectedImage})}
            value={attributes.image.id}
            allowedTypes={['image']}
            render={({open})=>(<>
            
              <Button
                className={attributes.mediaId == 0 ? 'editor-post-featured-image__toggle' : 'editor-post-featured-image__preview'}
                onClick={open}
                style={{position:"absolute",top:0,left:0,width:"100%",zIndex:42}}
              >
                Select Image
              </Button>
              
              </>)}

          />
        </MediaUploadCheck>
        <div className="imageHolder" style={{height:attributes.imageHeight+"px"}}>

            <img src={attributes.image?.url}/>
          </div>
          <div className={`textHolder ${attributes.textPosition}`}>
            <RichText style={{fontSize:attributes.headerFontSize+"px",color:attributes.headerColor}} tagName="h3" placeholder="Headline" value={attributes.mainText} onChange={(v)=>setAttributes({mainText:v})}/>
            <RichText style={{color:attributes.subTextColor}} tagName="p" placeholder="Supporting text..." value={attributes.subText} onChange={(v)=>setAttributes({subText:v})}/>
          </div>
        </div>
    </>);
  },
  save:function({attributes}){
    return (<a href={attributes.link?.url} className={`imageTextBlock ${attributes.styleVersion} ${attributes.showBorder ? "showBorder" : ""} ${attributes.roundedCorners ? "roundedCorners" : ""}`} style={{textAlign:attributes.textAlign}}>
      <div className="imageHolder" style={{height:attributes.imageHeight+"px"}}>
          <img src={attributes.image.url}/>
        </div>
        <div className={`textHolder ${attributes.textPosition}`}>
          <RichText.Content style={{fontSize:attributes.headerFontSize+"px",color:attributes.headerColor}} tagName="h3" value={attributes.mainText}/>
          <RichText.Content style={{color:attributes.subTextColor}} tagName="p" value={attributes.subText}/>
        </div>
      </a>);
  }
});
